import { loadBurbankCapPublishedBundle } from '../../burbankCapPublished/loadBurbankCapPublished';

export const BURBANK_CAP_COMPARISON_YEARS_SET = new Set([2010, 2019, 2022, 2024]);

function roundKwh(kwh: number): number {
  return Math.round(kwh);
}

function roundTherms(t: number): number {
  return Math.round(t);
}

export function burbankCapResidentialElectricityKwh(year: number): number | null {
  if (!BURBANK_CAP_COMPARISON_YEARS_SET.has(year)) return null;
  const row = loadBurbankCapPublishedBundle().capElectricity[String(year)];
  return row ? roundKwh(row.residential_kwh) : null;
}

export function burbankCapCommercialElectricityKwh(year: number): number | null {
  if (!BURBANK_CAP_COMPARISON_YEARS_SET.has(year)) return null;
  const row = loadBurbankCapPublishedBundle().capElectricity[String(year)];
  return row ? roundKwh(row.commercial_kwh) : null;
}

export function burbankCapResidentialGasTherms(year: number): number | null {
  if (!BURBANK_CAP_COMPARISON_YEARS_SET.has(year)) return null;
  const row = loadBurbankCapPublishedBundle().capGas[String(year)];
  return row ? roundTherms(row.residential_therms) : null;
}

export function burbankCapNonresidentialGasTherms(year: number): number | null {
  if (!BURBANK_CAP_COMPARISON_YEARS_SET.has(year)) return null;
  const row = loadBurbankCapPublishedBundle().capGas[String(year)];
  return row ? roundTherms(row.nonresidential_therms) : null;
}
